import firebase from '../../firebase';
import { useEffect, useState } from 'react';

export default function useActivity({
  orgId,
  subTaskId,
}: // expanded,
{
  orgId: string;
  subTaskId: string;
  // expanded: boolean;
}) {
  const [activity, setActivity] = useState<any[]>([]);

  useEffect(() => {
    if (!orgId || !subTaskId) return;
    let unsubscribe: any = null;
    unsubscribe = firebase
      .firestore()
      .collection(`orgs/${orgId}/activity`)
      .where('context.subTaskId', '==', subTaskId)
      .orderBy('createTime', 'desc')
      .limit(100)
      .onSnapshot(
        (query) => {
          if (!query.empty) {
            const list: any[] = query.docs.map((doc) => ({
              id: doc.id,
              ...doc.data(),
            }));
            setActivity(list);
          }
        },
        (error) => console.error(error)
      );
    return unsubscribe;
  }, [orgId, subTaskId]);

  return activity;
}
